module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-container",
    attrs: {
      "id": "nav-container"
    }
  }, [_c('div', {
    staticClass: "burgerBg",
    attrs: {
      "id": "buger"
    }
  }, [_c('div', {
    staticClass: "burger",
    class: {
      open: _vm.attachNav
    },
    on: {
      "click": function($event) {
        _vm.attachNav = !_vm.attachNav
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('nav', {
    staticClass: "menu",
    class: {
      open: _vm.attachNav
    },
    attrs: {
      "id": "menu"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/Top10'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleScroll($event)
      }
    }
  }, [_vm._v("首頁")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/Popular/result'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleScroll($event)
      }
    }
  }, [_vm._v("人氣口碑獎")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/Expert'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleScroll($event)
      }
    }
  }, [_vm._v("專業評審獎")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/Man'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleScroll($event)
      }
    }
  }, [_vm._v("COSMO型男最推")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/Asiatop10'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleScroll($event)
      }
    }
  }, [_vm._v("ASIA TOP 10")])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link fbBtn",
    on: {
      "click": function($event) {
        _vm.initfb()
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleScroll($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06325233","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 146
// module chunks = 0